import request from '../helpers/request';

const getRequestInvitationDays = async (requestId, errMsg) => {
  return await request.get(
    `/Request/invitation_days`,
    { requestId },
    errMsg || `При получении дат приемки произошла ошибка`
  );
};

export default getRequestInvitationDays;
